import React, { useEffect, useState } from "react";
import EventEmitter from "events";

import styles from "./Notification.module.css";

import closeIcon from "../icons/close.svg";
import { useLocation } from "react-router-dom";

const eventEmitter = new EventEmitter();

export const notify = (notificationContent, config = {}) => {
  eventEmitter.emit("notification", notificationContent, config);
};

//TODO: may be we can modify the notification to accept this config
// notify({
//   template: Failure,
//   message: "Please select at least one record",
// });

const Notification = () => {
  const location = useLocation();
  const [show, setShow] = useState(false);

  const [config, setConfig] = useState({
  animation: null,
  anchor: null,
  styles: null,
  closeIconProps: null,
  hideOnRouteChange: false,
});

  const [timeOutHolder, setTimeOutHolder] = useState(null);

  const [notification, setNotification] = useState(null);

  const handleClose = () => {
    setShow(false);
  };

  useEffect(() => {
    const handleNotification = (notificationContent, config) => {
      setConfig(config);
      setNotification(notificationContent);
      setShow(true);
      setTimeOutHolder((prevTimeOut) => {
        clearTimeout(prevTimeOut);
        return setTimeout(handleClose, 5000);
      });
    };
    eventEmitter.on("notification", handleNotification);
    return () => {
      eventEmitter.off("notification", handleNotification);
    };
  }, []);

  //  Hide notification on route change
  useEffect(() => {
    if (config.hideOnRouteChange)
    {
    setShow(false);
    clearTimeout(timeOutHolder);
    }
  }, [location]);

  return (
    <div className={[styles.Notification, show && styles.show].join(" ")}>
      <div className={styles.notificationContent}>
        {notification}
        <img
          className={styles.closeIcon}
          src={closeIcon}
          alt="dismiss"
          onClick={handleClose}
        />
      </div>
    </div>
  );
};

export default Notification;